<template>
  <div>
    <validation-observer ref="appointmentForm">
      <b-form-radio-group
          v-model="CHECKOUT_DATA.appointment"
          stacked
      >
        <b-form-radio value="1">
          Schnellstmöglich
        </b-form-radio>

        <b-form-radio value="2" style="margin-top: 5px">
          Ab Datum
        </b-form-radio>

        <div v-if="CHECKOUT_DATA.appointment == 2" class="mt-1">
          <div class="inner-section">
            <b-form-group label="Wunschtermin" label-for="appointment-date">
              <validation-provider
                  #default="{ errors }"
                  name="Wunschtermin"
                  rules="required"
                  vid="Wunschtermin"
              >
                <b-form-datepicker
                    v-model="CHECKOUT_DATA.appointment_date"
                    id="appointment-date"
                    placeholder="Wählen Sie bitte Ihren Wunschtermin aus"
                    local="de"
                    format="DD.MM.YYYY"
                    :min="minDate()"
                    :date-disabled-fn="dateDisabled"
                    label-calendar="Kalender"
                    label-close-button="Schließen"
                    label-current-month="aktueller Monat"
                    label-nav="Kalender Navigation"
                    label-next-decade="Nächste Dekade"
                    label-next-month="Nächster Monat"
                    label-next-year="Nächstes Jahr"
                    label-no-date-selected="Kein Datum ausgewählt"
                    label-prev-decade="Vorherige Dekade"
                    label-prev-month="Vorheriger Monat"
                    label-prev-year="Vorheriges Jahr"
                    label-today="Heute"
                    label-today-button="Heute auswählen"
                    :show-decade-nav="true"
                    label-help=""
                />
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <hr>
        </div>

        <b-form-radio value="3" style="margin-top: 5px"  v-if="SERVICE.name.toLowerCase() != 'pay-tv' && CHECKOUT_DATA.phoneline.option != 1">
          Direkt nach Vertragsende beim bisherigen Anbieter (keine doppelten Kosten)
        </b-form-radio>
      </b-form-radio-group>
    </validation-observer>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BFormRadioGroup,
  BFormRadio
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, required_if, email, digits} from '@validations'

export default {
  name: "AppointmentSection",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormRadioGroup,
    BFormRadio
  },
  data() {
    return {
      address: {},
      value: [],
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.appointmentForm.validate()
    },
    /**
     * @returns {number}
     */
    minDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      // 15th two months prior
      const minDate = new Date(today)
      return minDate
    },
    dateDisabled(ymd, date) {
      return false
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      const weekday = date.getDay()
      const day = date.getDate()
      const month = date.getMonth()

      let eastern = this.getEaster(date.getFullYear())
      let days = [-2, 0, 1, 39, 49, 50]

      let disableDay = false
      days.forEach(item => {
        let currentDate = new Date(eastern.getTime() + (item * 24 * 60 * 60 * 1000));
        if (currentDate.toDateString() == date.toDateString()) {
          disableDay = true
          return true
        }
      })

      return weekday === 0 || weekday === 6 ||
          (month === 11 && (day === 24 || day === 25 || day === 26 || day === 31)) ||
          (month === 9 && day === 3) || (month === 4 && day === 1) || disableDay
    },
    getEaster(year) {
      let f = Math.floor,
          // Golden Number - 1
          G = year % 19,
          C = f(year / 100),
          // related to Epact
          H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
          // number of days from 21 March to the Paschal full moon
          I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
          // weekday for the Paschal full moon
          J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
          // number of days from 21 March to the Sunday on or before the Paschal full moon
          L = I - J,
          month = 3 + f((L + 40) / 44),
          day = L + 28 - 31 * f(month / 4);

      let date = new Date(year, month - 1, day);

      return date;
    },
  },
  mounted() {
  }

}
</script>

<style scoped>

</style>
